import { User } from 'firebase/auth';

class AuthUtil {
  static RestrictedMessage = '権限無しのメッセージ';

  static restricted = async (currentUser: User | null | undefined, allowedMemberTypeLevel: number) => {
    return false;
    // if (!currentUser) return true;

    // let restricted = true;
    // await currentUser.getIdTokenResult()
    //   .then((idTokenResult) => {
    //     if (!idTokenResult.claims.memberType) return;
    //     if (Number(idTokenResult.claims.memberType) >= allowedMemberTypeLevel) {
    //       restricted = false;
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    
    // return restricted;
  }

}

export default AuthUtil